import { render } from "./OnboardingEmail.vue?vue&type=template&id=58f424d3"
import script from "./OnboardingEmail.vue?vue&type=script&lang=js"
export * from "./OnboardingEmail.vue?vue&type=script&lang=js"

import "./OnboardingEmail.vue?vue&type=style&index=0&id=58f424d3&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__